import { render, staticRenderFns } from "./SuccessModal.vue?vue&type=template&id=b13dd5b0&scoped=true&"
import script from "./SuccessModal.vue?vue&type=script&lang=js&"
export * from "./SuccessModal.vue?vue&type=script&lang=js&"
import style0 from "./SuccessModal.vue?vue&type=style&index=0&id=b13dd5b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b13dd5b0",
  null
  
)

export default component.exports